import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCross16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCross16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.464 3.758a.5.5 0 0 0-.707.707l3.536 3.536-3.535 3.535a.5.5 0 1 0 .707.707L8 8.708l3.535 3.535a.5.5 0 0 0 .707-.707L8.707 8.001l3.536-3.536a.5.5 0 1 0-.707-.707L8 7.294z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCross16);
